import { SITE } from "@/lib/site";
import { Mail, Phone, MessageCircle } from "lucide-react";

export function Footer() {
  const waHref = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <footer data-testid="footer" className="relative z-10 bg-midnight border-t border-border overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="font-serif text-3xl font-black text-ivory">Kairós<span className="text-crimson">.</span> Learning</div>
            <p className="font-sans text-base font-light text-ivory-muted mt-5 max-w-md leading-relaxed">
              La franquicia educativa 100% digital para Latinoamérica.
              Un negocio completo, sin el riesgo del ladrillo.
            </p>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-10">
            <div>
              <div className="font-sans text-xs uppercase tracking-[0.2em] text-crimson font-bold">Contacto</div>
              <ul className="mt-5 space-y-4">
                <li>
                  <a data-testid="footer-email" href={`mailto:${SITE.email}`} className="flex items-center gap-3 font-sans text-sm text-ivory-muted hover:text-ivory transition-colors">
                    <Mail className="w-4 h-4 text-crimson" /> {SITE.email}
                  </a>
                </li>
                <li>
                  <a data-testid="footer-phone" href={`tel:${SITE.phoneDisplay.replace(/\s/g, "")}`} className="flex items-center gap-3 font-sans text-sm text-ivory-muted hover:text-ivory transition-colors">
                    <Phone className="w-4 h-4 text-crimson" /> {SITE.phoneDisplay}
                  </a>
                </li>
                <li>
                  <a data-testid="footer-whatsapp" href={waHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 font-sans text-sm text-ivory-muted hover:text-ivory transition-colors">
                    <MessageCircle className="w-4 h-4 text-crimson" /> WhatsApp
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="font-sans text-xs uppercase tracking-[0.2em] text-crimson font-bold">Explorar</div>
              <ul className="mt-5 space-y-4">
                {[["El modelo", "solution"], ["Comparativo", "comparison"], ["Proceso", "how"], ["Aplicar", "registro"]].map(([l, id]) => (
                  <li key={id}>
                    <button
                      data-testid={`footer-link-${id}`}
                      onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                      className="font-sans text-sm text-ivory-muted hover:text-ivory transition-colors"
                    >
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-border flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-sans text-xs text-ivory-muted/60">© {new Date().getFullYear()} Kairós Learning. Todos los derechos reservados.</p>
          <p className="font-sans text-xs text-ivory-muted/60 max-w-md">Oportunidad de inversión sujeta a evaluación. Los resultados varían según la ejecución. No constituye promesa de rendimiento.</p>
        </div>
      </div>

      <div aria-hidden="true" className="select-none pointer-events-none w-full text-center leading-none">
        <span className="font-serif font-black text-ivory/[0.03] tracking-tighter" style={{ fontSize: "clamp(4rem, 20vw, 18rem)" }}>KAIRÓS</span>
      </div>
    </footer>
  );
}
